import { io } from 'socket.io-client';

const server = process.env.REACT_APP_BASE_API_URL.replace('/api', '');

export const socket = io(server);
socket.on('connect', () => {
    
});
